var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data.contents),function(content,index){return _c(_vm.isComponent(content),{key:index,tag:"component",attrs:{"data":content},on:{"action":_vm.onAction}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }